// Copyright 2020 Sorama B.V.

import { PLATFORM } from "aurelia-pal";
import { GuidanceTopicType, IGuidanceTopic } from "catalogs/GuidanceCatalog";
import { WorkflowModuleType } from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";
import { WorkflowModes } from "services/WorkflowModes/WorkflowModes";

export class OtherGuidanceCatalog {
    static OtherGS1Module: IGuidanceTopic = {
        name: "Other_Q1", // https://sorama.atlassian.net/wiki/spaces/UI/pages/720175827/O1+User+credits+how+to+ensure+I+can+always+work+with+the+CAM
        modulePath: PLATFORM.moduleName("guidance/Other/O1UserCredits.html"),
        title: "Other",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All,
        topicType: GuidanceTopicType.Question,
        topicContent: "User credits, how to ensure I can always work with the CAM?",
        catchwords: [""],
        hidden: true,
    };
    static OtherGS2Module: IGuidanceTopic = {
        name: "Other_Q2", // https://sorama.atlassian.net/wiki/spaces/UI/pages/720044698/O2+How+does+Sorama+Software-as-a-service+work
        modulePath: PLATFORM.moduleName("guidance/Other/O2SoramaSoftwareServiceWork.html"),
        title: "Other",
        moduleType: WorkflowModuleType.Help,
        relevantWorkflowModes: WorkflowModes.All,
        topicType: GuidanceTopicType.Question,
        topicContent: "How does Sorama Software-as-a-service work?",
        catchwords: [""],
    };
}
